import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { trackPageview } from 'js/utils/tracking';
import { METADATA_CMS_IDS, PAGE_IDS } from 'js/constants/Pages';

// import components
import SiteMetaData from 'js/components/generic/Generic.metadata';

// import actions
import { getSiteMetaData, getCurrentPageData } from '../store/app/App.selectors';

const PagePrivacyPolicy = (props) => {
  const meta = useSelector((state) => {
    return getSiteMetaData(state, METADATA_CMS_IDS[PAGE_IDS.privacy_policy]);
  });

  useEffect(() => {
    trackPageview({ title: 'Privacy Policy', path: props.path });
  }, []);

  const pageData = useSelector((state) => {
    return getCurrentPageData(state, PAGE_IDS.privacy_policy);
  });

  const { title = 'Privacy Policy', description = '' } = pageData?.content || {};
  return (
    <div className="blue-background privacy-policy">
      <div className="container">
        <SiteMetaData {...meta} />
        <h1 style={{ textAlign: 'center', marginBottom: 45 }}>{title}</h1>
        <div className="wysiwyg" dangerouslySetInnerHTML={{ __html: description }} />
      </div>
    </div>
  );
};

export default PagePrivacyPolicy;
